<div provideParentForm>
    <avi-fieldset>
        <avi-fieldset_header class="match-wrapper__avi-fieldset-header">
            <div class="match-wrapper__header">
                <label
                    aviLabelWithTooltip
                    objectType="{{ objectType }}"
                    fieldName="{{ fieldName }}"
                >
                    {{ label }}
                    <span
                        *ngIf="subLabel"
                        class="match-wrapper__header-sub-label"
                    >
                        {{ subLabel }}
                    </span>
                </label>
                <button
                    type="button"
                    (click)="removeMatch()"
                    [hidden]="!showRemoveIcon"
                    class="match-wrapper__remove-icon"
                >
                    <cds-icon
                        shape="trash"
                        size="18"
                        status="info"
                    ></cds-icon>
                </button>
            </div>
        </avi-fieldset_header>
        <avi-fieldset_content>
            <ng-content></ng-content>
        </avi-fieldset_content>
    </avi-fieldset>
</div>
